import React from "react";

import PageHeading from "2g-page-heading";
import ZadostiRowDetail from "b2b/components/zadosti-row-detail/ZadostiRowDetail";

const ZADOSTI = require("b2b-devel/zadosti/seznam.json");

export function ZadostiRowDetailExample() {
  return (
    <>
      <PageHeading>ZadostiRowDetail</PageHeading>
      <ZadostiRowDetail dataRow={ZADOSTI[0]} />
    </>
  );
}

export default React.memo(ZadostiRowDetailExample);
